











































































































import {
  Component,
  PropSync,
  Emit,
  Prop,
  Ref,
  Watch
} from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { defaultSystemCode, SystemCode } from '@/api'
import {
  BibliographySearchType,
  DisplayMethod,
  NarrowTarget,
  SearchTarget
} from '@/types'
import { ButtonToggle } from '@/components/molecules/ButtonToggle'
import { IButtonToggleItem } from '@/components/molecules/ButtonToggle/ButtonToggle.type'
import { InputCode } from '@/components/molecules/InputCode'
import { ModalSelectFormat } from '@/components/modals/ModalSelectFormat'
import { AtomTextField } from '@/components/atoms'

export interface InputBibliographySearchResultsOption {
  selectedOnly: {
    input: string
  }
  canLendOnly: {
    input: string
  }
  displayBranchCode: {
    input: SystemCode
    errorMessage: string
  }
  narrowKeyword: {
    input: string
    errorMessage: string
  }
  narrowTarget: {
    input: NarrowTarget
    errorMessage: string
  }
  isNarrowSearched: boolean
  displayMethod: {
    input: DisplayMethod
  }
}

export const defaultInputBibliographySearchResultsOption = (): InputBibliographySearchResultsOption => ({
  selectedOnly: {
    input: ''
  },
  canLendOnly: {
    input: ''
  },
  displayBranchCode: {
    input: defaultSystemCode(),
    errorMessage: ''
  },
  narrowKeyword: {
    input: '',
    errorMessage: ''
  },
  narrowTarget: {
    input: NarrowTarget.Title,
    errorMessage: ''
  },
  isNarrowSearched: false,
  displayMethod: {
    input: DisplayMethod.Simple
  }
})

@Component({
  components: {
    ModalSelectFormat,
    InputCode,
    ButtonToggle
  }
})
export default class BibliographySearchResultsOption extends ComponentVue {
  @Ref()
  modalSelectFormat!: ModalSelectFormat

  @Ref()
  narrowKeywordInputCode!: InputCode

  @Ref()
  narrowKeywordTextField!: AtomTextField

  @PropSync('input', {
    type: Object,
    required: true
  })
  internalItem!: InputBibliographySearchResultsOption

  @Prop({
    type: Boolean,
    required: true
  })
  existsItems!: boolean

  @Prop({
    type: String,
    required: true
  })
  searchTarget!: SearchTarget

  @Prop({
    type: String,
    required: true
  })
  searchType!: BibliographySearchType

  toggleItems: IButtonToggleItem[] = [
    { value: DisplayMethod.Simple, text: '一' },
    { value: DisplayMethod.Detail, text: '二' }
    // { value: '3', text: '三' }
  ]

  get displayNarrowSearch(): boolean {
    return this.searchTarget === SearchTarget.Db
  }

  get isNarrowTargetMaterialFormat(): boolean {
    return this.internalItem.narrowTarget.input === NarrowTarget.MaterialFormat
  }

  get narrowTargets(): IButtonToggleItem[] {
    return [
      { value: NarrowTarget.Title, text: 'タイトル' },
      { value: NarrowTarget.Author, text: '責任表示' },
      { value: NarrowTarget.Publisher, text: '出版者' },
      { value: NarrowTarget.MaterialFormat, text: '資料形態' },
      { value: NarrowTarget.FreeWord, text: 'フリーワード' }
    ]
  }

  @Watch('isNarrowTargetMaterialFormat')
  onChangeIsNarrowTargetMaterialFormat(): void {
    this.internalItem.narrowKeyword.input = defaultInputBibliographySearchResultsOption().narrowKeyword.input
  }

  focusNarrowKeyword(): void {
    if (this.isNarrowTargetMaterialFormat) {
      if (this.narrowKeywordInputCode) {
        this.narrowKeywordInputCode.textField.atomTextField.focus()
      }
    } else if (this.narrowKeywordTextField) {
      this.narrowKeywordTextField.atomTextField.focus()
    }
  }

  openModalSelectFormat(): void {
    this.modalSelectFormat.open({
      onNormalDisplay: this.onDownloadList,
      onTwoRowDisplay: this.onDownloadDetailList
    })
  }

  existsErrorMessage(errorMessage: string): boolean {
    return !!errorMessage
  }

  resetErrorMessage(obj: any): void {
    obj.errorMessage = ''
  }

  @Emit('click:selected-only')
  onClickSelectedOnly() {}

  @Emit('click:can-lend-only')
  onClickCanLendOnly() {}

  @Emit('click:reload')
  onClickReload() {}

  @Emit('click:narrow')
  onClickNarrow() {}

  @Emit('keydown:enter:narrow')
  onKeydownEnterNarrow() {}

  @Emit('click:narrow-clear')
  onClickNarrowClear() {}

  @Emit('download:list')
  onDownloadList() {}

  @Emit('download:detail-list')
  onDownloadDetailList() {}
}
